import { Button } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { steps } from "../../../Utility/utils";
import styles from "./Step.module.css";
import GenerateCertifiacte from "../../../Components/GenerateCertifiacte/GenerateCertifiacte";
import AdditionalNotes from "../../../Components/AdditionalNotes/AdditionalNotes";
import {
  consumptionEngText,
  consumptionGermText,
} from "../../../Components/Pannel/Pannel";

function NavButton({
  handleSubmit,
  disabled = false,
  show = true,
  showPrint = false,
  showPop = false,
  ...props
}) {
  const { state } = useContext(AppContext);
  const { stepLanguage, language } = state;

  const [showForm, setShowForm] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const showButton = () => {
    setShowForm((prev) => !prev);
  };
  useEffect(() => {
    if (showPop) {
      setShowForm((prev) => !prev);
    }
  }, [showPop]);

  return (
    <>
      <div className={styles.desk}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
          className={styles.buttonClass}
        >
          <Button
            variant="outlined"
            disabled={state.page <= 1}
            onClick={() => handleSubmit(state.page - 1, "prev")}
            sx={{
              padding: "12px 25px",
              borderRadius: "10px",
              background: "white",
              visibility: `${state.page <= 1 ? "hidden" : "visible"}`,
              // boxShadow: "none",
              // color: "white",
              // "&:disabled": {
              //   background: "gray",
              //   color: "#ccc",
              // },
            }}
          >
            <b>
              {" "}
              {language == "de"
                ? consumptionGermText?.Previous
                : consumptionEngText?.Previous}
            </b>
          </Button>
          <div style={{ display: "flex" }}>
            <Button
              variant="contained"
              // disabled={state.needPage <= 1}
              sx={{
                padding: "12px 25px",
                marginRight: "10px",
                // marginRight: "10px",
                background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                boxShadow: "none",
                borderRadius: "10px",
                color: "white",
                "&:disabled": {
                  background: "gray",
                  color: "#ccc",
                },
              }}
              onClick={() => setOpenDialog((prev) => !prev)}
            >
              {language == "de"
                ? consumptionGermText?.notes_docs
                : consumptionEngText?.notes_docs}
            </Button>
            {showPrint ? (
              <Button
                variant="contained"
                disabled={state.page <= 1}
                onClick={() => showButton(null, "save")}
                sx={{
                  padding: "12px 25px",
                  background:
                    " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                  boxShadow: "none",
                  borderRadius: "10px",
                  color: "white",
                  "&:disabled": {
                    background: "gray",
                    color: "#ccc",
                  },
                }}
              >
                <b>
                  {language == "de"
                    ? consumptionGermText?.save_changes
                    : consumptionEngText?.save_changes}
                </b>
              </Button>
            ) : (
              <div>
                {/* <Button
                  variant="outlined"
                  disabled={state.page <= 1}
                  onClick={() => handleSubmit(null, "save")}
                  sx={{
                    padding: "12px 25px",
                    borderRadius: "10px",
                    background: "white",
                    // boxShadow: "none",
                    // color: "white",
                    // "&:disabled": {
                    //   background: "gray",
                    //   color: "#ccc",
                    // },
                    marginRight: "10px",
                  }}
                >
                  <b>Save & Resume Later</b>
                </Button> */}
              </div>
            )}
            {show && (
              <Button
                variant="contained"
                disabled={disabled || state.page === steps.length}
                onClick={() => handleSubmit(state.page + 1, "next")}
                sx={{
                  padding: "12px 25px",
                  background:
                    " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                  boxShadow: "none",
                  borderRadius: "10px",
                  color: "white",
                  "&:disabled": {
                    background: "gray",
                    color: "#ccc",
                  },
                }}
              >
                <b>
                  {language == "de"
                    ? consumptionGermText?.next
                    : consumptionEngText?.next}
                </b>
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className={styles.mobile}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
          className={styles.buttonClass}
        >
          <Button
            variant="outlined"
            disabled={state.page <= 1}
            onClick={() => handleSubmit(state.page - 1, "prev")}
            sx={{
              padding: "12px 25px",
              borderRadius: "10px",
              background: "white",
              // boxShadow: "none",
              // color: "white",
              // "&:disabled": {
              //   background: "gray",
              //   color: "#ccc",
              // },
            }}
          >
            <b>
              {" "}
              {language == "de"
                ? consumptionGermText?.Previous
                : consumptionEngText?.Previous}
            </b>
          </Button>
          <div>
            {show && (
              <Button
                variant="contained"
                disabled={disabled || state.page === steps.length}
                onClick={() => handleSubmit(state.page + 1, "next")}
                sx={{
                  padding: "12px 25px",
                  background:
                    " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                  boxShadow: "none",
                  borderRadius: "10px",
                  color: "white",
                  "&:disabled": {
                    background: "gray",
                    color: "#ccc",
                  },
                }}
              >
                <b>
                  {language == "de"
                    ? consumptionGermText?.next
                    : consumptionEngText?.next}
                </b>
              </Button>
            )}
          </div>
        </div>

        <div className={styles.save}>
          {showPrint ? (
            <Button
              variant="contained"
              disabled={state.page <= 1}
              onClick={() => {
                showButton(null, "save");
                alert("cheking");
              }}
              sx={{
                padding: "12px 25px",
                background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                boxShadow: "none",
                borderRadius: "10px",
                color: "white",
                "&:disabled": {
                  background: "gray",
                  color: "#ccc",
                },
              }}
            >
              <b>
                {" "}
                {language == "de"
                  ? consumptionGermText?.save_changes
                  : consumptionEngText?.save_changes}
              </b>
            </Button>
          ) : (
            <Button
              variant="outlined"
              disabled={state.page <= 1}
              onClick={() => handleSubmit(null, "save")}
              sx={{
                padding: "12px 25px",
                borderRadius: "10px",
                background: "white",
                // boxShadow: "none",
                // color: "white",
                // "&:disabled": {
                //   background: "gray",
                //   color: "#ccc",
                // },
                marginRight: "10px",
              }}
            >
              <b>
                {" "}
                {language == "de"
                  ? consumptionGermText?.save_resume
                  : consumptionEngText?.save_resume}
              </b>
            </Button>
          )}
        </div>
        <GenerateCertifiacte show={showForm} setShow={setShowForm} />
        <AdditionalNotes
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          type={1}
        />
      </div>
    </>
  );
}

export default NavButton;
